<template>
    <div>
        <vx-card v-for="(item, index) in results" :key="index">
            <div class="issue-card p-4 mb-3" slot="no-body" v-if="item.data">
                <vs-row class="m-0 p-0">
                    <vs-col class="px-0 pr-1" vs-xs="11" vs-sm="11" vs-lg="11">
                        <h4 class="m-0">Issue # {{ item.data.id }}</h4>
                        <small class="block">
                            <span class="font-bold"><FormatText :text="issue_type" format="select" :kwargs="issue_type_options" /> :</span> {{ issue_category(item) }}
                        </small>
                        <small class="block">
                            <span class="font-bold">Date & Time:</span> <FormatText :text="item.created_on" format="datetime" />
                        </small>
                        <vs-row>
                            <vs-col class="px-0 flex" vs-xs="12" vs-lg="12" vs-sm="12" vs-align="center"> 
                                <small class="font-bold mr-2">Approval Status:</small>
                                <small v-if="item.status == 'p'" class="text-warning font-bold block">
                                    Pending
                                </small>
                                <small v-else-if="item.status == 'r'" class="text-danger font-bold block">
                                    Rejected
                                </small>
                                <small v-else-if="item.status == 'a'" class="text-success font-bold block">
                                    Approved
                                </small>
                                <template v-if="item.status == 'r' && editIssue(item)">
                                    <router-link :to="{name: 'issues-edit', params: {issue_type: item.issue_type, issue_id: item.id}}">
                                        <vs-button type="filled" size="small" color="primary" class="px-2 py-1 mx-1">Edit Issue</vs-button>
                                    </router-link>
                                </template>   
                            </vs-col>
                            <template v-if="item.resource_allocation">
                                <vs-col class="px-0 flex" vs-xs="12" vs-lg="12" vs-sm="12" vs-align="center"> 
                                    <template v-if="item.resource_allocation == 'e'">
                                        <small class="font-bold mr-2">RS (SE/PO): </small>
                                        <template>
                                            <small v-if="item.resolution_status_se == null" class="text-warning font-bold block mr-3">
                                                -
                                            </small>
                                            <small v-else-if="item.resolution_status_se == 'p'" class="text-warning font-bold block mr-3">
                                                Pending
                                            </small>
                                            <small v-else-if="item.resolution_status_se == 'r'" class="text-danger font-bold block mr-3">
                                                Rejected
                                            </small>
                                            <small v-else-if="item.resolution_status_se == 'a'" class="text-success font-bold block mr-3">
                                                Approved
                                            </small>
                                        </template>
                                    </template>
                                    <small class="font-bold mr-2">RS:</small>
                                    <template>
                                        <small v-if="item.resolution_status == null" class="text-warning font-bold block">
                                            -
                                        </small>
                                        <small v-else-if="item.resolution_status == 'p'" class="text-warning font-bold block">
                                            Pending
                                        </small>
                                        <small v-else-if="item.resolution_status == 'r'" class="text-danger font-bold block">
                                            Rejected
                                        </small>
                                        <small v-else-if="item.resolution_status == 'a'" class="text-success font-bold block">
                                            Approved
                                        </small>
                                        <template v-if="item.status == 'a'">
                                            <router-link :to="{name: 'issues-resolution', params: {issue_type: item.issue_type, issue_id: item.id}}">
                                                <vs-button type="filled" size="small" color="primary" class="px-2 py-1 mx-1">
                                                    Resolution
                                                </vs-button>
                                            </router-link>
                                        </template>
                                    </template>
                                </vs-col>
                            </template>
                        </vs-row>
                    </vs-col>
                    <vs-col class="px-1 text-right flex" vs-align="center" vs-xs="1" vs-sm="1" vs-lg="1">
                        <router-link :to="{name: 'issues-view', params: {issue_type: issue_type, issue_id: item.id}}">
                            <vs-button type="flat" class="px-1 py-1" size="large" color="primary">
                                <font-awesome-icon :icon="rightIcon" />
                            </vs-button>
                        </router-link>
                    </vs-col>
                </vs-row>
            </div>
        </vx-card>
    </div>
</template>

<script>
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
export default {
    props: {
        results: {
            type: Array,
            required: true
        },
        issue_type: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            issue_type_options: [
                {label: 'Issue Category', value: 'highway'},
                {label: 'Issue Category', value: 'routine_maintenance'},
                {label: 'Issue Category', value: 'major_maintenance'},
                {label: 'Issue Category', value: 'electrical_maintenance'},
                {label: 'Nature of Accident', value: 'road_user_accident'},
                {label: 'Accident Classification', value: 'occupational'},
                {label: 'Issue Category', value: 'hazard'},
                {label: 'Type of Vehicle', value: 'vehicle_breakdown'},
                {label: 'Type of Vehicle', value: 'traffic_violation'},
                {label: 'Type of Vehicle', value: 'unauthorised_parking'},
                {label: 'Material Damage', value: 'material_damage'},
                {label: 'Incident Details', value: 'other'},
                {label: 'Type of Enroachment', value: 'enroachment_row'},
                {label: 'Action Taken', value: 'unauthorised_access'},
                {label: 'Action Taken', value: 'unauthorised_media_cut'},
                {label: 'Action Taken', value: 'dead_animal_debris_removal'},

            ],
        }
    },
    computed: {
        rightIcon: () => faChevronRight,
    },
    methods: {
        issue_category (item) {
            if (this.issue_type == 'highway') {
                return item['data']['category']['name']

            } else if (this.issue_type == 'routine_maintenance') {
                return item['data']['category']['name']

            }  else if (this.issue_type == 'major_maintenance') {
                return item['data']['category']['name']

            } else if (this.issue_type == 'electrical_maintenance') {
                return item['data']['category']['name']

            } else if (this.issue_type == 'road_user_accident') {
                return item['data']['nature_of_accident']['name']
                
            } else if (this.issue_type == 'occupational') {
                return item['data']['accident_classification']['name']
                
            } else if (this.issue_type == 'hazard') {
                return item['data']['category']['name']
                
            } else if (this.issue_type == 'vehicle_breakdown') {
                return item['data']['vehicle_type']['name']
                
            } else if (this.issue_type == 'traffic_violation') {
                return item['data']['vehicle_type']['name']
                
            } else if (this.issue_type == 'unauthorised_parking') {
                return item['data']['vehicle_type']['name']
                
            } else if (this.issue_type == 'material_damage') {
                return item['data']['material_damaged']

            } else if (this.issue_type == 'other') {
                return item['data']['incident']

            }  else if (this.issue_type == 'enroachment_row') {
                return item['data']['enroachment_type']['name']

            }  else if (this.issue_type == 'unauthorised_access') {
                return item['data']['action_taken']

            }  else if (this.issue_type == 'unauthorised_media_cut') {
                return item['data']['action_taken']

            }  else if (this.issue_type == 'dead_animal_debris_removal') {
                return item['data']['action_taken']

            }
        },
        editIssue(item) { 
            return this.hasAccess('edit', `issue_${item.issue_type}`, ['all', 'own'], [item.reported_by.id])
        }
    }
}
</script>